var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useState } from 'react';
import { CheckIcon, ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { Translate } from "../../../I18N";
import { Label } from "../Forms";









const CopyValueInput = ({ value, className, label, id, hideLabel }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
  };

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => {
        setCopied(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
    return () => {};
  }, [copied]);

  return /*#__PURE__*/(
    _jsx("div", { className: `${className || ''}` }, void 0, /*#__PURE__*/
    _jsx(Label, { htmlFor: id, hideLabel: hideLabel }, void 0,
    label
    ), /*#__PURE__*/
    _jsx("div", { className: "relative w-full" }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "text",
      disabled: true,
      value: value,
      id: id,
      className: "disabled:text-gray-500 rounded-lg bg-gray-50 block flex-1 w-full text-sm p-2.5" }
    ), /*#__PURE__*/
    _jsx("div", { className: "absolute right-0 flex items-center top-px" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      onClick: copyToClipboard,
      "data-testid": "copy-value-button",
      className: "hover:text-primary-700 text-gray-900 p-2.5 text-sm font-medium rounded-r-lg focus:outline-none" }, void 0,


    copied ? /*#__PURE__*/
    _jsx(CheckIcon, { className: "w-5 text-success-600" }) : /*#__PURE__*/

    _jsx(ClipboardDocumentIcon, { className: "w-5" }), /*#__PURE__*/


    _jsx(Translate, { className: "sr-only" }, void 0, "Copy to clipboard")
    ),
    copied && /*#__PURE__*/
    _jsx("div", {
      role: "tooltip",
      className: "absolute right-0 z-10 inline-block px-3 py-2 text-sm font-medium bg-white rounded-lg shadow-sm -top-11 w-max border-gray-50" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Copied to clipboard")
    )

    )
    )
    ));

};

export { CopyValueInput };